import React, { useEffect, useState } from "react";
import SlideUpWrapper from "../../../../../components/Transitions/SlideUpWrapper";
import Icon from "react-icons-kit";
import { androidArrowBack } from "react-icons-kit/ionicons/androidArrowBack";
import styles from "./RequestDetails.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { _ToNormal, setDate } from "../../../../../Utils/helper";

import API from "../../../../../ApiConfig";
import {
  BASE_URL,
  CREATE_APPEAL,
  GET_APPEAL_METADATA_VERIFIER,
  USER_TOKEN,
} from "../../../../../Utils/constant";
import cogoToast from "cogo-toast-react-17-fix";
import useRefreshToken from "../../../../../Hooks/usegenerateToken";
import ReactPortalModal from "../../../../../components/ReactPortalModal";
import Loader from "../../../../../components/Loader";
import Dropdown from "../../../../../components/Inputs/Dropdown";

// The employment field is identified by its normalized label. Options come from
// the field metadata when supplied, otherwise fall back to this list.
const EMPLOYMENT_FIELD_LABEL = "Employment Type";
const EMPLOYMENT_OPTIONS = ["Intern", "Full-time", "Trainee"];

const isEmploymentField = (field) =>
  typeof _ToNormal(field?.field_name) === "string" &&
  _ToNormal(field?.field_name).trim() === EMPLOYMENT_FIELD_LABEL;

const CreateAppeal = ({ id }) => {
  useRefreshToken(BASE_URL + USER_TOKEN);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [preview, setPreview] = useState("");

  const navigate = useNavigate();
  const { issued_doc_id, issuer_id, verification_request_id } = useParams();
  const location = useLocation();

  console.log(location);
  const requestId = location?.state?.request_id;

  const [data, setData] = useState(
    null
    // {
    //     name: "Jack",
    //     email: "jack@jack.com",
    //     phone_number: "9999999999",
    //     created_at: "2025-05-05T16:21:28.605967",
    //     form_type: "Document",

    //     fields:
    //     [
    //         {
    //           id: 1,
    //           field_name: "first_name",
    //           original_value: "Jack",
    //           value: "",
    //           checked:false
    //         },
    //         {
    //           id: 2,
    //           field_name: "date_of_joining",
    //           original_value: "02-02-2015",
    //           value: "",
    //           checked:false
    //         },
    //         {
    //           id: 3,
    //           field_name: "date_of_leaving",
    //           original_value: "01-02-2022",
    //           value: "",
    //           checked:false
    //         },
    //         {
    //           id: 4,
    //           field_name: "emp_id",
    //           original_value: "123",
    //           value: "",
    //           checked:false
    //         },
    //         {
    //           id: 5,
    //           field_name: "company_name",
    //           original_value: "Auth Company",
    //           value: "",
    //           checked:false
    //         }

    //       ]
    // }
  );

  const [fieldsData, setFieldsData] = useState([]);
  const [comment, setComment] = useState("");
  const [file, setFile] = useState("");

  useEffect(() => {
    getAppealData();
  }, []);
  const getAppealData = () => {
    setLoading(true);
    API.get(GET_APPEAL_METADATA_VERIFIER + id + "/" + issued_doc_id)
      .then((res) => {
        if (res.data.status == 201) {
          setLoading(false);
          setData(res.data.data);
          setFieldsData(res.data.data.fields);
        }
      })
      .catch((err) => {
        cogoToast.error(err.response.data.detail);
      });
  };
  useEffect(() => {
    if (data?.verifier_remarks) {
      setComment(data.verifier_remarks);
    }
  }, [data]);
  const handleChange = (id, newValue) => {
    setFieldsData((prev) =>
      prev.map((fields, i) =>
        fields.id === id ? { ...fields, value: newValue } : fields
      )
    );
  };
  const handleCheckBox = (id, checked) => {
    setFieldsData((prev) =>
      prev.map((fields, i) =>
        fields.id === id ? { ...fields, checked, value: "" } : fields
      )
    );
  };

  const validateFieldData = () => {
    let isValid = true;
    if (!fieldsData.some((field) => field.value && field.value.trim() !== "")) {
      isValid = false;
      cogoToast.error("enter data to raise appeal");
    } else if (!file) {
      isValid = false;
      cogoToast.error("Please add file to procced ");
    } else if (comment.trim() == "") {
      isValid = false;
      cogoToast.error("Please give some remarks");
    } else {
      for (let item of fieldsData) {
        if (item.value && item.regex[0]) {
          const pattern = new RegExp(item.regex[0]);
          if (!pattern.test(item.value)) {
            isValid = false;
            cogoToast.error(
              `Invalid new value enter for ${_ToNormal(item.field_name)}`
            );
          }
        }
      }
    }
    return isValid;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateFieldData()) {
      return;
    } else {
      const requestedFields = {};
      fieldsData.forEach((item) => {
        if (item.value !== "" && item.checked) {
          requestedFields[item.id] = item.value;
        }
      });
      const formdata = new FormData();
      formdata.append("verifier_id", id);
      formdata.append("issuer_id", issuer_id);
      formdata.append("issued_document_id", issued_doc_id);
      formdata.append("verifier_payload", JSON.stringify(requestedFields));
      formdata.append("verification_request_id", verification_request_id);
      formdata.append("verifier_remarks", comment);
      formdata.append("supporting_document_upload", file);
      setSubmitLoading(true);
      API.post(CREATE_APPEAL, formdata)
        .then((res) => {
          setSubmitLoading(false);
          if (res.data.status == 201) {
            navigate("/dashboard/emp/requests");
          }
        })

        .catch((err) => {
          setSubmitLoading(false);
          cogoToast.error(err.response.data.detail[0]);
        });
    }
  };
  const DocPreview = () => {
    var loading = {
      padding: "1rem",
      height: "10vh",
      width: "-webkit-fill-available",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };
    if (!preview) {
      return <div style={loading}>Loading Pdf ...</div>;
    } else {
      return (
        <embed
          key={preview}
          id="pdf-viewer"
          src={preview + "#toolbar=0"}
          type="application/pdf"
          style={{width:"700px", height:"500px"}}
        />
      );
    }
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <Loader isOpen={loading} />
        <SlideUpWrapper direction="slide-left">
          <div>
            <h2 className={styles.header}>
              <Icon
                icon={androidArrowBack}
                size={"1.2rem"}
                onClick={() =>
                  navigate(
                    `../emp/requestDetails/${requestId}/${issuer_id}/${verification_request_id}`
                  )
                }
                style={{ cursor: "pointer" }}
              />
              {loading ? (
                <div className="shimmer" style={{ width: "10rem" }} />
              ) : (
                "Create Appeal"
              )}
            </h2>
            <div className={styles.section}>
              <div className={styles.mainContainer}>
                <div className={styles.tableHeader}>
                  <h3 className="heading">
                    {loading ? (
                      <div className="shimmer" style={{ width: "10rem" }} />
                    ) : (
                      data?.name
                    )}
                  </h3>
                  <div className={styles.basicDetails}>
                    {/* <div>
                                        <span className="heading">Phone</span>
                                        <span>{loading ? <div className="shimmer" /> : data?.phone_number}</span>
                                    </div>
                                    <div>
                                        <span className="heading">Email</span>
                                        <span>{loading ? <div className="shimmer" style={{ width: '10rem' }} /> : data?.email}</span>
                                    </div> */}
                    {data?.appeal_raised_on !== null && (
                      <div>
                        <span className="heading">Appeal Raised on</span>
                        <span>
                          {loading ? (
                            <div
                              className="shimmer"
                              style={{ width: "10rem" }}
                            />
                          ) : (
                            setDate(data?.appeal_raised_on)
                          )}
                        </span>
                      </div>
                    )}
                    {data?.appeal_raised && (
                      <div>
                        <span className="heading">Appeal Status</span>
                        <span>
                          {loading ? (
                            <div
                              className="shimmer"
                              style={{ width: "10rem" }}
                            />
                          ) : (
                            <div
                              className={`${
                                data?.status === "PENDING_ON_ISSUER"
                                  ? "Pending"
                                  : data?.status == "DENIED"
                                  ? "Rejected"
                                  : "Complete"
                              }`}
                              style={{ width: "auto", height: "auto" }}
                            >
                              {_ToNormal(data?.status)}
                            </div>
                          )}
                        </span>
                      </div>
                    )}
                    {data?.issuer_remarks &&
                    <div>
                        <span className="heading">Remarks</span>
                        <span>
                          {loading ? (
                            <div
                              className="shimmer"
                              style={{ width: "10rem" }}
                            />
                          ) : (
                            data.issuer_remarks
                          )}
                        </span>
                      </div>}
                  </div>
                </div>
                {data?.status === "PENDING_ON_ISSUER" ||
                data?.status === "DENIED" ||
                data?.status === null ? (
                  <div>
                    <table style={{ width: "100%", textAlign: "left" }}>
                      <tbody>
                        {fieldsData &&
                          fieldsData.map((item, index) => (
                            <tr
                              key={index}
                              className="credentials-header1"
                              style={{ alignItems: "center" }}
                            >
                              <td
                                key={index}
                                className="credentials-header1"
                                style={{ alignItems: "center" }}
                              >
                                <td
                                  className="credentials-td"
                                  style={{
                                    justifyContent: "flex-start",
                                    width: "15rem",
                                  }}
                                >
                                  {_ToNormal(item.field_name)}
                                </td>
                              </td>
                              <td
                                key={index}
                                className="credentials-header1"
                                style={{ alignItems: "center" }}
                              >
                                <td
                                  className="credentials-td"
                                  style={{
                                    justifyContent: "flex-start",
                                    width: "15rem",
                                  }}
                                >
                                  {item.original_value}
                                </td>
                              </td>
                              <td
                                key={index}
                                className="credentials-header1"
                                style={{ alignItems: "center" }}
                              >
                                <td
                                  className="credentials-td"
                                  style={{
                                    justifyContent: "flex-start",
                                    width: "15rem",
                                  }}
                                >
                                  {/* <input type="checkbox" className={styles.input} checked={item.checked} onChange={(e)=>handleCheckBox(item.id,e.target.checked)}/>  */}
                                  <div className="checkbox-wrapper-22">
                                    <label
                                      className="switch"
                                      htmlFor={`checkbox ${item.id}`}
                                    >
                                      <input
                                        type="checkbox"
                                        id={`checkbox ${item.id}`}
                                        checked={item.checked}
                                        onChange={(e) =>
                                          handleCheckBox(
                                            item.id,
                                            e.target.checked
                                          )
                                        }
                                        disabled={data?.appeal_raised}
                                      />
                                      <div className="slider round"></div>
                                    </label>
                                  </div>
                                </td>
                              </td>
                              <td
                                key={index}
                                className="credentials-header1"
                                style={{ alignItems: "center" }}
                              >
                                <td
                                  className="credentials-td"
                                  style={{
                                    justifyContent: "flex-start",
                                    width: "15rem",
                                  }}
                                >
                                  {" "}
                                  {isEmploymentField(item) ? (
                                    <Dropdown
                                      options={item.options ?? EMPLOYMENT_OPTIONS}
                                      value={item.value}
                                      placeholder={item.placeholder || "Select..."}
                                      disabled={
                                        !item.checked || data?.appeal_raised
                                      }
                                      onChange={(val) =>
                                        handleChange(item.id, val)
                                      }
                                    />
                                  ) : (
                                    <input
                                      type="text"
                                      className={styles.input}
                                      value={item.value}
                                      onChange={(e) =>
                                        handleChange(item.id, e.target.value)
                                      }
                                      disabled={
                                        !item.checked || data?.appeal_raised
                                      }
                                    />
                                  )}{" "}
                                </td>
                              </td>
                            </tr>
                          ))}

                        <tr
                          className="credentials-header1"
                          style={{ alignItems: "center" }}
                        >
                          <td
                            className="credentials-header1"
                            style={{
                              alignItems: "center",
                              padding: "1rem",
                              fontSize: "16px",
                              fontWeight: "500",
                            }}
                          >
                            <td
                              className="credentials-td"
                              style={{
                                justifyContent: "flex-start",
                                width: "15rem",
                              }}
                            >{`Please upload the supporting document for adding details (Service Letter, Experience Letter)`}</td>
                          </td>
                          <td
                            className="credentials-header1"
                            style={{
                              width: "15rem",
                            }}
                          ></td>
                          <td
                            className="credentials-header1"
                            style={{
                              width: "15rem",
                            }}
                          ></td>
                          <td
                            className="credentials-header1"
                            style={{ width: "15rem", padding: "1rem" }}
                          >
                            {data?.appeal_raised ?
                            <td
                            className="credentials-td"
                            style={{
                              width: "15rem",
                              fontSize: "16px",
                              fontWeight: "500",
                               alignItems:"center"
                            }}
                          >
                                <a
                                    href={data?.supporting_document_url}
                                    target="_blank"
                                >
                      Supporting Document
                    </a>
                    </td>: (
                              <div>
                                <input
                                  type="file"
                                  onChange={(e) => setFile(e.target.files[0])}
                                  accept=".pdf"
                                  style={{ width: "90%" }}
                                />
                              </div>
                            )}
                          </td>
                        </tr>
                        <tr
                          className="credentials-header1"
                          style={{ alignItems: "center" }}
                        >
                          <td
                            className="credentials-header1"
                            style={{
                              width: "15rem",
                              fontSize: "16px",
                              fontWeight: "500",
                              textAlign: "center",
                            }}
                          >
                            <td
                              className="credentials-td"
                              style={{
                                justifyContent: "center",
                                width: "15rem",
                              }}
                            >
                              Please Share your comments/remarks
                            </td>
                          </td>
                          <td
                            className="credentials-header1"
                            style={{
                              width: "15rem",
                            }}
                          ></td>
                          <td
                            className="credentials-header1"
                            style={{
                              width: "15rem",
                            }}
                          ></td>
                          <td
                            className="credentials-header1"
                            style={{ padding: "1rem" }}
                          >
                            <div>
                              <textarea
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                className={styles.AppealComment}
                                placeholder="Enter Comment"
                                disabled={data?.appeal_raised}
                                title="Verifier Remarks"
                                style={{ width: "15rem" }}
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {data?.appeal_raised ? null : (
                      <div
                        style={{
                          display: "flex",
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={(e) => handleSubmit(e)}
                          disabled={data?.appeal_raised}
                        >
                          {submitLoading ? "Submitting..." : "Create Appeal"}
                        </button>
                      </div>
                    )}
                  </div>
                ) : loading ? (
                  <div className="shimmer" style={{ width: "10rem" }}></div>
                ) : (
                  <table style={{ width: "100%", textAlign: "left" }}>
                    <tbody>
                  {fieldsData && Object.entries(fieldsData).map(([key, value], index) => {
                    return(
                      <tr key={index} className="credentials-header1" style={{ alignItems: 'center' }}>
                    <td
                          className="credentials-td"
                          style={{
                            justifyContent: "flex-start",
                            maxWidth: "10rem",
                          }}
                        >{_ToNormal(value.field_name)}</td>
                    <td
                          className="credentials-td"
                          style={{ justifyContent: "flex-start" }}
                        >{value.issuer_value?value.issuer_value : value.original_value}</td>
                    </tr>)})}
                    {!data?.hide_pdf &&  <tr
                        className="credentials-header1"
                        style={{ alignItems: "center" }}
                      >
                        <td
                          className="credentials-td"
                          style={{
                            justifyContent: "flex-start",
                            maxWidth: "10rem",
                          }}
                        >
                          New Document
                        </td>
                        <td
                          className="credentials-td"
                          style={{ justifyContent: "flex-start" }}
                        >
                          {data?.new_issued_document_full_pdf ? (
                            <button
                              className="btn btn-secondary"
                              onClick={(e) =>
                                setPreview(
                                  data?.new_issued_document_full_pdf
                                    ? data?.new_issued_document_full_pdf
                                    : null
                                )
                              }
                              style={{
                                display: "flex",
                                gap: "0.3rem",
                                textDecoration: "none",
                              }}
                            >
                              <img
                                className={styles.downloadOutlineIcon}
                                alt=""
                                src="/downloadoutline.svg"
                              />
                              View PDF
                            </button>
                          ) : (
                            "Document Link Expired"
                          )}
                        </td>
                      </tr>}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </SlideUpWrapper>
        <ReactPortalModal
          title={"Issued New Document"}
          isOpen={preview}
          onClose={(e) => setPreview(null)}
        >
          <DocPreview />
        </ReactPortalModal>
      </div>
    </>
  );
};

export default CreateAppeal;
